module.exports = __webpack_public_path__ + "static/media/chat.ab910fad.jpg";